import React from 'react';
import PropTypes from 'prop-types';
import { animated, useSpring } from '@react-spring/web';
import Carousel from './Carousel';
import DataModel from '../../models/dataModel';

function renderMenuLogo() {
	const logo = DataModel.getMenuAttribute('logo', true);
	if (logo) {
		const logoPath = `content/${logo}`;
		return <img className="logo" src={logoPath} alt="" />;
	}
	return null;
}

function renderOverlayImage() {
	const image = DataModel.getMenuAttribute('overlayImage', true);
	if (image) {
		const imagePath = `content/${image}`;
		return <img className="menu-overlay" src={imagePath} alt="" />;
	}
	return null;
}

const MenuView = ({ state, actions }) => {
	const { activeViewID, activeMediaID, activePopupID, carousel, activeSponsorSlot } = state;
	const { setView, setCarousel, setMedia, fadeSound, playVideo, resetTimer } = actions;
	const isViewHome = activeViewID === 'home';
	const carouselGroups = DataModel.getCarouselGroups(activeSponsorSlot);
	let title = DataModel.getMenuAttribute('title', true);
	if (title) {
		title = title.replace('[br]', '\n');
	}
	const description = DataModel.getMenuAttribute('description', true);
	const ariaHidden =
		activeViewID === 'home' || activeViewID === 'map' || activeMediaID !== '' || activePopupID !== '';
	const pointerEvents = ariaHidden ? 'none' : 'auto';
	const { opacity, overlayY, containerY } = useSpring({
		opacity: isViewHome ? 0 : 1,
		overlayY: isViewHome ? -150 : 0,
		containerY: isViewHome ? 150 : 0,
	});
	const overlayTransform = overlayY.to((value) => `translate3D(0, ${value}px, 0)`);
	const containerTransform = containerY.to((value) => `translate3D(0, ${value}px, 0)`);
	return (
		<div>
			<div id="menu" tabIndex="-1" aria-hidden={ariaHidden} style={{ pointerEvents }}>
				<animated.div style={{ opacity }}>
					<div className="backdrop" style={{ opacity: 0.65 }} />
				</animated.div>
				<animated.div className="menu-overlay-container" style={{ transform: overlayTransform, opacity }}>
					{renderOverlayImage()}
				</animated.div>
				<animated.div className="menu-content" style={{ transform: overlayTransform, opacity }}>
					<div className="text">
						<h1 className="heading">{title}</h1>
						<p className="description">{description}</p>
					</div>
					{renderMenuLogo()}
				</animated.div>
				<animated.div className="container" style={{ transform: containerTransform, opacity }}>
					<Carousel
						carousel={carousel}
						carouselGroups={carouselGroups}
						setView={setView}
						setCarousel={setCarousel}
						setMedia={setMedia}
						fadeSound={fadeSound}
						playVideo={playVideo}
						resetTimer={resetTimer}
					/>
				</animated.div>
			</div>
		</div>
	);
};

MenuView.propTypes = {
	state: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
};

export default React.memo(MenuView);
